(function () {
  var content = document.querySelector(".m-article__content");
  var toc = document.getElementById("article-toc");
  if (!content || !toc) return;

  var list = toc.querySelector(".m-article-toc__list");
  var usedIds = {};
  var headings = [];

  content.querySelectorAll("h2, h3").forEach(function (heading) {
    var text = heading.textContent.trim();
    if (!text) return;

    var id = text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");
    if (usedIds[id]) {
      usedIds[id]++;
      id = id + "-" + usedIds[id];
    } else {
      usedIds[id] = 1;
    }
    heading.id = id;
    headings.push({ id: id, text: text, sub: heading.tagName === "H3" });
  });

  // Safety net: if the page has fewer than 2 real headings (e.g. the Liquid parse and
  // the DOM ever disagree), show no TOC rather than a box with 0-1 links.
  if (headings.length < 2) {
    toc.style.display = "none";
    return;
  }

  // The list is server-rendered (snippets/article-toc.liquid) so it takes its space at
  // first paint; here we only point each link at its heading. If the Liquid parse ever
  // disagrees with the DOM, rebuild the list rather than link to the wrong heading.
  var links = list.querySelectorAll(".m-article-toc__link");
  if (links.length === headings.length) {
    headings.forEach(function (h, i) {
      links[i].href = "#" + h.id;
    });
  } else {
    list.textContent = "";
    headings.forEach(function (h) {
      var li = document.createElement("li");
      li.className = h.sub
        ? "m-article-toc__item m-article-toc__item--sub"
        : "m-article-toc__item";
      var a = document.createElement("a");
      a.href = "#" + h.id;
      a.textContent = h.text;
      a.className = "m-article-toc__link";
      li.appendChild(a);
      list.appendChild(li);
    });
  }

  // Toggle collapse
  var toggle = toc.querySelector(".m-article-toc__toggle");
  var nav = toc.querySelector(".m-article-toc__nav");
  toggle.addEventListener("click", function () {
    var expanded = toggle.getAttribute("aria-expanded") === "true";
    toggle.setAttribute("aria-expanded", String(!expanded));
    nav.style.display = expanded ? "none" : "";
  });

  // Smooth scroll. scrollIntoView + CSS scroll-margin-top instead of measuring with
  // getBoundingClientRect, which forced a synchronous layout of the whole article
  // inside the click handler (a measured INP cost on mobile).
  list.addEventListener("click", function (e) {
    var link = e.target.closest(".m-article-toc__link");
    if (!link) return;
    var target = document.getElementById(link.getAttribute("href").slice(1));
    if (!target) return;
    e.preventDefault();
    // Yield first so the tap paints; the scroll needs a full layout of the article.
    setTimeout(function () {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      history.replaceState(null, "", link.getAttribute("href"));
    }, 0);
  });
})();
